module.exports = __webpack_public_path__ + "static/media/JUNGHEINRICH-ESC-316Z-2.a440be80.jpg";